<script lang="ts">
  import('App/DealershipReport').then((m) => {
    let module = m.default;

    new module({
      target: document.getElementById('dealership-report'),
      layout: 'auto',

      props: {
        schema: {
          visibility: {
            readOnly: true,
          },
        },
        defaultFilter: {
          from_date: '2025-06-01',
          to_date: '2026-01-01',
        },
        quickFilters: [
          {
            label: 'mbd-cashback-2025',
            filter: {
              from_date: '2025-10-01',
              to_date: '2026-01-01',
            },
          },
          {
            label: 'mbd-cashback-2025-october',
            filter: {
              from_date: '2025-10-01',
              to_date: '2025-11-01',
            },
          },
          {
            label: 'mbd-cashback-2025-november',
            filter: {
              from_date: '2025-11-01',
              to_date: '2025-12-01',
            },
          },
          {
            label: 'mbd-cashback-2025-december',
            filter: {
              from_date: '2025-12-01',
              to_date: '2026-01-01',
            },
          },
          {
            label: 'week-40',
            filter: {
              from_date: '2025-10-01',
              to_date: '2025-10-06',
            },
          },
          {
            label: 'week-41',
            filter: {
              from_date: '2025-10-06',
              to_date: '2025-10-13',
            },
          },
          {
            label: 'week-42',
            filter: {
              from_date: '2025-10-13',
              to_date: '2025-10-20',
            },
          },
          {
            label: 'week-43',
            filter: {
              from_date: '2025-10-20',
              to_date: '2025-10-27',
            },
          },
          {
            label: 'week-44',
            filter: {
              from_date: '2025-10-27',
              to_date: '2025-11-04',
            },
          },
          {
            label: 'week-45',
            filter: {
              from_date: '2025-11-03',
              to_date: '2025-11-10',
            },
          },
          {
            label: 'week-46',
            filter: {
              from_date: '2025-11-10',
              to_date: '2025-11-17',
            },
          },
          {
            label: 'week-47',
            filter: {
              from_date: '2025-11-17',
              to_date: '2025-11-24',
            },
          },
          {
            label: 'week-48',
            filter: {
              from_date: '2025-11-24',
              to_date: '2025-12-01',
            },
          },
          {
            label: 'week-49',
            filter: {
              from_date: '2025-12-01',
              to_date: '2025-12-08',
            },
          },
          {
            label: 'week-50',
            filter: {
              from_date: '2025-12-08',
              to_date: '2025-12-15',
            },
          },
          {
            label: 'week-51',
            filter: {
              from_date: '2025-12-15',
              to_date: '2025-12-22',
            },
          },
          {
            label: 'week-52',
            filter: {
              from_date: '2025-12-22',
              to_date: '2025-12-29',
            },
          },
          {
            label: 'week-53',
            filter: {
              from_date: '2025-12-29',
              to_date: '2026-01-01',
            },
          },
        ],
      },
    });
  });
</script>

<div id="dealership-report" />
